export const TableIcon = ({ className }) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.66667 11.3346H6.13333C5.38659 11.3346 5.01323 11.3346 4.72801 11.1893C4.47713 11.0615 4.27315 10.8575 4.14533 10.6066C4 10.3214 4 9.94804 4 9.2013V7.33464C4 7.9559 4 8.2665 4.10149 8.51157C4.23682 8.83824 4.49639 9.09784 4.82309 9.23317C5.06812 9.33464 5.37875 9.33464 6 9.33464M2 5.33464H14M8 7.33464H12M8.66667 9.33464H12M4.13333 13.3346H11.8667C12.6134 13.3346 12.9868 13.3346 13.272 13.1893C13.5229 13.0615 13.7269 12.8575 13.8547 12.6066C14 12.3214 14 11.948 14 11.2013V4.8013C14 4.05457 14 3.6812 13.8547 3.39598C13.7269 3.1451 13.5229 2.94112 13.272 2.8133C12.9868 2.66797 12.6134 2.66797 11.8667 2.66797H4.13333C3.3866 2.66797 3.01323 2.66797 2.72801 2.8133C2.47713 2.94112 2.27315 3.1451 2.14533 3.39598C2 3.6812 2 4.05456 2 4.8013V11.2013C2 11.948 2 12.3214 2.14533 12.6066C2.27315 12.8575 2.47713 13.0615 2.72801 13.1893C3.01323 13.3346 3.38659 13.3346 4.13333 13.3346Z"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
